export const BackgroundColor = '#755321'
export const BackgroundColorSecondary = '#9e7334'

export const white = '#ffffff'
export const text2 = '#9b9ba9'